const formatAttributeValue = (value) => {
  if (value === null || value === undefined) {
    return '';
  }
  if (Array.isArray(value)) {
    return value.join(', ');
  }
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch (err) {
      return String(value);
    }
  }
  return String(value);
};

const convertOthersToAttributes = (others) => {
  if (!others || typeof others !== 'object') {
    return [];
  }
  return Object.entries(others).map(([attribute, value]) => ({
    attribute,
    value: formatAttributeValue(value)
  }));
};

const formatFieldLabel = (key) => key
  .replace(/_/g, ' ')
  .replace(/\b\w/g, (char) => char.toUpperCase());

const getNetworkFailureMessage = () => (
  'Cannot reach the recognition service. Please check your connection '
  + 'or try again shortly.'
);

const mapApiDataToFieldGroups = (data = {}) => {
  const skipKeys = new Set(['username', 'image_url', 'others']);
  const primaryFields = Object.entries(data)
    .filter(([key]) => !skipKeys.has(key))
    .map(([key, value]) => ({
      key,
      label: formatFieldLabel(key),
      value: formatAttributeValue(value)
    }));

  const additionalFields = convertOthersToAttributes(data.others);

  return { primaryFields, additionalFields };
};

export {
  formatAttributeValue,
  getNetworkFailureMessage,
  mapApiDataToFieldGroups
};

